import { type ProgramGuideItem, ContentType } from "@ca.vmedia.tv/domains";
import { CardDataType, type ImageCardData, type PlayCardData, ComponentName } from "../types";

export class ProgramCardData implements ImageCardData, PlayCardData {

    private readonly program: ProgramGuideItem;
    private readonly timeOnly: boolean;

    constructor(item: ProgramGuideItem, timeOnly: boolean = true) {
        this.program = item;
        this.timeOnly = timeOnly;
    }

    getId(): string {
        return `${this.program.recentAirTime?.id}`;
    }

    getImage(): string {
        return this.program.image ?? '';
    }

    getPlayItem(): ProgramGuideItem {
        return this.program;
    }

    getClass(): string {
        return 'program-card';
    }

    getType(): CardDataType {
        return CardDataType.Guide;
    }

    getContentType(): ContentType {
        return ContentType.DVR;
    }

    getComponentName(): ComponentName {
        return ComponentName.PROGRAM;
    }

    getProgram(): ProgramGuideItem {
        return this.program;
    }

    isTimeOnly(): boolean {
        return this.timeOnly;
    }
    setPosition(pos: number): void {
        this.program.streamPosition = pos;
    }
}
